export const OfflineStorageKeyAllowAutoRefresh = "esitqappedu-allow-auto-refresh";
